// extracted by mini-css-extract-plugin
export default {"answer":"index_answer_UZ4zu"};